export * from '@fhs/routing/src/routes/(tabs)/(more)/account/index';
export { default } from '@fhs/routing/src/routes/(tabs)/(more)/account/index';
